import logo2023 from "../../assets/img/nxtEvents/LogoNoMercy/NoMercy.png";
import logo2024 from "../../assets/img/nxtEvents/LogoNoMercy/NoMercy2024.png";
import logo2025 from "../../assets/img/nxtEvents/LogoNoMercy/NoMercy2025.png";

export const nxtNoMercyDetail = {
  "nxt-no-mercy": {
    id: "nxt-no-mercy",
    title: "NXT No Mercy",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "nxt-no-mercy",
        items: [
          {
            id: "nxt-no-mercy-2023",
            title: "No Mercy",
            description: "2023",
            imgUrl: logo2023,
          },
          {
            id: "nxt-no-mercy-2024",
            title: "No Mercy",
            description: "Denver 2024",
            imgUrl: logo2024,
          },
          {
            id: "nxt-no-mercy-2025",
            title: "No Mercy",
            description: "2025",
            imgUrl: logo2025,
          },
        ],
      },
    ],
  },
};
